module.exports = __webpack_public_path__ + "img/settings.fec94f05.svg";